var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('section',{staticClass:"padding_30 padbot_45"},[_c('app-title',{attrs:{"label":"Blog"}}),_c('p',{staticClass:"top_30"},[_vm._v("COMING SOON")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }